/**
 * ResponsiveClockIn.tsx
 *
 * Wrapper that shows bare MobileClockIn on mobile (< 768px) and
 * MobileClockIn embedded inside Layout on desktop (>= 768px).
 * On desktop, the Layout sidebar/header is used and the mobile blue header is hidden.
 */
import React, { useState, useEffect } from 'react';
import Layout from './Layout';
import MobileClockIn from '../pages/Mobile/MobileClockIn';

const MOBILE_BREAKPOINT = 768;

const ResponsiveClockIn: React.FC = () => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) {
    return <MobileClockIn />;
  }

  return (
    <Layout>
      <MobileClockIn embedded />
    </Layout>
  );
};

export default ResponsiveClockIn;
